import * as CSS from "csstype";
import { transportCategory, TransportCategory } from "@ots-frontend/ots-data";
import { transportCategoryOilColor, transportCategoryWaterColor } from "../theme/colors";

/**
 * Returns the color for the transport category.
 *
 * @param category the transport category
 */
export const getTransportCategoryColor = (
  category: TransportCategory
): CSS.Property.Color => {
  switch (category) {
    case transportCategory.water:
      return transportCategoryWaterColor;
    case transportCategory.oil:
      return transportCategoryOilColor;
    default:
      return transportCategoryWaterColor;
  }
};

export const getTransportCategoryColorRefByType = (category: TransportCategory): string => {
  switch (category) {
    case transportCategory.oil:
      return "transport-category-oil";
    default:
      return "transport-category-water";
  }
};
